export const categories = [
  {
    slug: 'crime-thriller',
    name: '犯罪悬疑',
    description: '韩国犯罪悬疑电影以其缜密的剧情设计、深刻的人性刻画闻名于世，从《杀人回忆》到《寄生虫》，每一部都是类型片的巅峰之作。',
    icon: 'ri-shield-flash-line',
  },
  {
    slug: 'romance-drama',
    name: '爱情剧情',
    description: '韩国爱情电影以细腻的情感描绘著称，将爱情的甜蜜与苦涩展现得淋漓尽致，引发观众内心深处的共鸣。',
    icon: 'ri-heart-line',
  },
  {
    slug: 'horror-thriller',
    name: '恐怖惊悚',
    description: '韩国恐怖电影融合了东亚传统文化元素与现代叙事手法，创造出独特的恐惧美学体验。',
    icon: 'ri-ghost-line',
  },
  {
    slug: 'action-adventure',
    name: '动作冒险',
    description: '韩国动作电影以拳拳到肉的真实感和紧张的节奏把控，在国际影坛赢得了一席之地。',
    icon: 'ri-sword-line',
  },
  {
    slug: 'social-realism',
    name: '社会现实',
    description: '韩国社会现实题材电影敢于直面社会问题，通过电影语言表达对社会不公的批判与思考。',
    icon: 'ri-scales-line',
  },
  {
    slug: 'historical',
    name: '历史题材',
    description: '韩国历史题材电影将历史的厚重感与戏剧张力完美结合，再现了朝鲜半岛波澜壮阔的历史画卷。',
    icon: 'ri-ancient-gate-line',
  },
];

export const movies = [
  {
    id: 'parasite',
    title: '寄生虫',
    year: 2019,
    director: '奉俊昊',
    categorySlug: 'social-realism',
    rating: 9.2,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20Parasite%20film%20poster%20style%20cinematic%20with%20dramatic%20lighting%2C%20minimalist%20design%2C%20dark%20moody%20atmosphere%2C%20Korean%20cinema%20aesthetic%2C%20high%20contrast%2C%20film%20grain%20texture%2C%20family%20drama%20thriller&width=600&height=900&seq=parasite-2019-poster&orientation=portrait',
    summary: '基宇一家四口全是无业游民，他们偶然进入富裕的朴社长家工作，两个家庭的命运由此交织在一起，引发了一连串出人意料的事件。',
    cast: ['宋康昊', '李善均', '赵汝贞', '崔宇植', '朴素丹'],
    runtime: '132分钟',
    awards: ['第92届奥斯卡最佳影片', '戛纳金棕榈奖', '奥斯卡最佳导演'],
  },
  {
    id: 'oldboy',
    title: '老男孩',
    year: 2003,
    director: '朴赞郁',
    categorySlug: 'crime-thriller',
    rating: 8.8,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20Oldboy%20film%20poster%20style%20cinematic%20revenge%20thriller%2C%20dark%20moody%20red%20tones%2C%20minimalist%20design%2C%20Korean%20cinema%20aesthetic%2C%20high%20contrast%20noir%20style&width=600&height=900&seq=oldboy-2003-poster&orientation=portrait',
    summary: '吴大秀在醉酒后被不明人士绑架，在私人监狱中度过15年后突然获释。他开始寻找被囚禁的原因，却发现真相远比想象中更加残酷。',
    cast: ['崔岷植', '刘智泰', '姜惠贞'],
    runtime: '120分钟',
    awards: ['戛纳电影节评审团大奖'],
  },
  {
    id: 'the-handmaiden',
    title: '小姐',
    year: 2016,
    director: '朴赞郁',
    categorySlug: 'romance-drama',
    rating: 8.6,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20The%20Handmaiden%20film%20poster%20style%20period%20drama%20romance%2C%20elegant%20dark%20aesthetic%2C%201930s%20Korean%20setting%2C%20minimalist%20design%2C%20high%20contrast&width=600&height=900&seq=the-handmaiden-2016-poster&orientation=portrait',
    summary: '1930年代日本殖民时期的朝鲜，女仆淑熙被派往富家小姐秀子家中，一场精心策划的骗局由此展开，而两人之间却产生了超越阶级与阴谋的情感。',
    cast: ['金敏喜', '金泰梨', '河正宇', '赵震雄'],
    runtime: '144分钟',
    awards: ['戛纳电影节竞赛单元', '英国电影学院奖最佳外语片'],
  },
  {
    id: 'train-to-busan',
    title: '釜山行',
    year: 2016,
    director: '延尚昊',
    categorySlug: 'horror-thriller',
    rating: 8.5,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20Train%20to%20Busan%20zombie%20horror%20film%20poster%2C%20intense%20action%20thriller%2C%20train%20setting%2C%20dark%20atmosphere%2C%20cinematic%20Korean%20aesthetic%2C%20high%20contrast&width=600&height=900&seq=train-to-busan-2016-poster&orientation=portrait',
    summary: '一列从首尔开往釜山的高铁上，丧尸病毒突然爆发。乘客们必须在封闭的空间中与恐怖的感染者搏斗，人性的光辉与黑暗在危机中展露无遗。',
    cast: ['孔刘', '郑裕美', '马东锡', '金秀安', '崔宇植'],
    runtime: '118分钟',
    awards: ['戛纳电影节午夜展映'],
  },
  {
    id: 'burning',
    title: '燃烧',
    year: 2018,
    director: '李沧东',
    categorySlug: 'crime-thriller',
    rating: 8.4,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20Burning%20film%20poster%20mystery%20drama%2C%20minimalist%20design%2C%20warm%20sunset%20tones%2C%20contemplative%20mood%2C%20Korean%20cinema%20arthouse%20aesthetic&width=600&height=900&seq=burning-2018-poster&orientation=portrait',
    summary: '快递员钟秀偶遇童年好友海美，两人关系逐渐升温之际，海美从非洲旅行带回的神秘男子本介入其中。一场关于嫉妒、阶级与秘密的游戏悄然展开。',
    cast: ['刘亚仁', '史蒂文·元', '全钟瑞'],
    runtime: '148分钟',
    awards: ['戛纳电影节竞赛单元', '戛纳电影节费比西奖'],
  },
  {
    id: 'memories-of-murder',
    title: '杀人回忆',
    year: 2003,
    director: '奉俊昊',
    categorySlug: 'crime-thriller',
    rating: 9.0,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20Memories%20of%20Murder%20crime%20thriller%20film%20poster%2C%20dark%20noir%20style%2C%20investigation%20theme%2C%20rainy%20atmosphere%2C%20Korean%20cinema%20classic%2C%20high%20contrast&width=600&height=900&seq=memories-of-murder-2003-poster&orientation=portrait',
    summary: '1986年，韩国京畿道华城郡发生连环奸杀案。两名性格迥异的警察联手追查凶手，但案件始终悬而未决，正义似乎永远遥不可及。',
    cast: ['宋康昊', '金相庆', '金雷夏'],
    runtime: '131分钟',
    awards: ['韩国电影大钟奖最佳影片'],
  },
  {
    id: 'a-taxi-driver',
    title: '出租车司机',
    year: 2017,
    director: '张勋',
    categorySlug: 'historical',
    rating: 8.7,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20A%20Taxi%20Driver%20historical%20drama%20film%20poster%2C%201980s%20setting%2C%20warm%20yellow%20taxi%20theme%2C%20emotional%20storytelling%2C%20Korean%20cinema%20aesthetic&width=600&height=900&seq=a-taxi-driver-2017-poster&orientation=portrait',
    summary: '1980年光州事件期间，一位普通的首尔出租车司机为了高额报酬，载着一位德国记者潜入被封锁的光州，在见证了真相后做出了改变人生的选择。',
    cast: ['宋康昊', '托马斯·克莱舒曼', '柳俊烈', '柳海真'],
    runtime: '137分钟',
    awards: ['韩国电影青龙奖最佳影片'],
  },
  {
    id: 'decision-to-leave',
    title: '分手的决心',
    year: 2022,
    director: '朴赞郁',
    categorySlug: 'romance-drama',
    rating: 8.2,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20Decision%20to%20Leave%20romance%20mystery%20film%20poster%2C%20elegant%20noir%20style%2C%20foggy%20mountain%20atmosphere%2C%20sophisticated%20design%2C%20Korean%20cinema%20aesthetic&width=600&height=900&seq=decision-to-leave-2022-poster&orientation=portrait',
    summary: '刑警海俊在调查一起登山坠亡案件时，死者妻子瑞莱的平静态度引起了他的怀疑。随着调查深入，海俊发现自己对这位神秘女子产生了难以抗拒的吸引力。',
    cast: ['朴海日', '汤唯', '李贞贤'],
    runtime: '138分钟',
    awards: ['戛纳电影节最佳导演'],
  },
  {
    id: 'the-wailing',
    title: '哭声',
    year: 2016,
    director: '罗泓轸',
    categorySlug: 'horror-thriller',
    rating: 8.1,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20The%20Wailing%20horror%20film%20poster%2C%20folk%20horror%20supernatural%2C%20dark%20ritualistic%20atmosphere%2C%20ominous%20village%20setting%2C%20Korean%20cinema%20aesthetic%2C%20high%20contrast&width=600&height=900&seq=the-wailing-2016-poster&orientation=portrait',
    summary: '一个偏远山村接连发生离奇命案，村民们陷入恐慌。警察钟九在调查过程中，发现了一系列超自然现象，而一位神秘的日本人的到来让事情变得更加扑朔迷离。',
    cast: ['郭度沅', '黄政民', '国村隼'],
    runtime: '156分钟',
    awards: ['戛纳电影节非竞赛展映'],
  },
  {
    id: 'spring-summer-fall-winter',
    title: '春夏秋冬又一春',
    year: 2003,
    director: '金基德',
    categorySlug: 'social-realism',
    rating: 8.5,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20Spring%20Summer%20Fall%20Winter%20film%20poster%2C%20zen%20Buddhist%20temple%20on%20lake%2C%20serene%20nature%20setting%2C%20meditative%20atmosphere%2C%20minimalist%20design%2C%20Korean%20arthouse%20cinema&width=600&height=900&seq=spring-summer-2003-poster&orientation=portrait',
    summary: '一座漂浮于湖面的寺庙中，老僧与童僧相依为命。四季轮回，童僧经历成长、欲望、罪孽与救赎，生命的哲理在静谧的山水之间徐徐展开。',
    cast: ['吴永洙', '金基德', '金永敏', '徐在京'],
    runtime: '103分钟',
    awards: ['洛迦诺国际电影节金豹奖'],
  },
  {
    id: 'the-host',
    title: '汉江怪物',
    year: 2006,
    director: '奉俊昊',
    categorySlug: 'action-adventure',
    rating: 8.0,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20The%20Host%20monster%20action%20film%20poster%2C%20creature%20feature%2C%20Han%20River%20setting%2C%20dark%20thriller%20atmosphere%2C%20family%20drama%2C%20Korean%20cinema%20aesthetic&width=600&height=900&seq=the-host-2006-poster&orientation=portrait',
    summary: '汉江中出现了一只巨大的变异怪物，掳走了小吃店老板的女儿。一家人不顾政府封锁，凭借亲情的力量踏上了营救之旅。',
    cast: ['宋康昊', '卞熙奉', '朴海日', '裴斗娜'],
    runtime: '119分钟',
    awards: ['亚洲电影大奖最佳影片'],
  },
  {
    id: 'i-saw-the-devil',
    title: '看见恶魔',
    year: 2010,
    director: '金知云',
    categorySlug: 'crime-thriller',
    rating: 8.3,
    posterUrl: 'https://readdy.ai/api/search-image?query=Korean%20movie%20I%20Saw%20the%20Devil%20revenge%20thriller%20film%20poster%2C%20dark%20violent%20noir%20style%2C%20intense%20psychological%20drama%2C%20Korean%20cinema%20aesthetic%2C%20high%20contrast&width=600&height=900&seq=i-saw-the-devil-2010-poster&orientation=portrait',
    summary: '特工秀贤的未婚妻被连环杀手残忍杀害后，他展开了一场疯狂的复仇。但这场猫鼠游戏逐渐模糊了正义与邪恶的界限，复仇者也在一步步走向深渊。',
    cast: ['李秉宪', '崔岷植'],
    runtime: '144分钟',
    awards: ['韩国电影青龙奖最佳男主角'],
  },
];

export const articles = [
  {
    id: 'art-1',
    title: '奉俊昊的电影世界：从《杀人回忆》到《寄生虫》的叙事进化',
    slug: 'bong-joon-ho-narrative-evolution',
    excerpt: '从2003年的《杀人回忆》到2019年获得奥斯卡的《寄生虫》，奉俊昊用十六年时间完成了类型片叙事的华丽蜕变。本文深度解析他如何将社会批判融入商业类型片的叙事结构之中。',
    content: `<p>奉俊昊是当代韩国电影最具代表性的导演之一。他的作品跨越多种类型，却始终贯穿着对社会阶层的深刻洞察与批判。</p>
<h3>早期探索：《杀人回忆》的类型突破</h3>
<p>2003年上映的《杀人回忆》改编自韩国真实的华城连环杀人案。奉俊昊并未选择传统犯罪片的叙事方式，而是将镜头对准了办案过程中的无力感与挫败感。影片结尾处，宋康昊直视镜头的画面成为韩国电影史上最震撼的瞬间之一——这不仅是对凶手的凝视，更是对整个社会体制的无声控诉。</p>
<p>这部电影确立了奉俊昊标志性的风格：在类型片框架中嵌入尖锐的社会评论，让商业性与作者性达成微妙平衡。</p>
<h3>巅峰之作：《寄生虫》的阶层寓言</h3>
<p>《寄生虫》是奉俊昊艺术成就的集大成者。影片通过半地下室、豪宅和地下避难所三层空间，构建了一个关于阶层固化的现代寓言。奉俊昊将黑色幽默、惊悚元素和社会批判熔于一炉，创造出一种前所未有的观影体验。</p>
<p>2019年，《寄生虫》成为首部获得奥斯卡最佳影片的非英语电影，这不仅是对奉俊昊个人才华的认可，更标志着韩国电影在全球范围内的全面崛起。</p>
<h3>奉俊昊的叙事密钥</h3>
<p>回顾奉俊昊的作品序列，我们可以发现他独特的叙事策略：以类型片为基石建立观众期待，再通过反类型的手法颠覆这些期待。他的电影永远在问：谁是真正的怪物？——这个问题既指向银幕上的角色，也指向银幕外的我们。</p>`,
    author: '金志勋',
    date: '2026-07-20',
    categorySlug: 'social-realism',
    relatedMovieId: 'parasite',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20cinema%20film%20analysis%20article%20cover%2C%20Bong%20Joon%20ho%20director%20portrait%20style%2C%20cinematic%20photography%20with%20warm%20tones%2C%20film%20reel%20and%20spotlight%20aesthetic%2C%20editorial%20design%2C%20sophisticated%20visual&width=800&height=500&seq=article-bong-joon-ho&orientation=landscape',
  },
  {
    id: 'art-2',
    title: '朴赞郁的复仇三部曲：人性深渊中的美学探索',
    slug: 'park-chan-wook-revenge-trilogy',
    excerpt: '从《我要复仇》到《老男孩》再到《亲切的金子》，朴赞郁用复仇三部曲重新定义了暴力美学的边界。本文带你深入了解这三部曲背后的哲学思考与视觉语言。',
    content: `<p>朴赞郁是韩国电影美学的开拓者，他的复仇三部曲——《我要复仇》（2002）、《老男孩》（2003）和《亲切的金子》（2005）——将暴力与诗意完美融合，创造出一种独特的美学语言。</p>
<h3>复仇的表象与本质</h3>
<p>三部电影都以复仇为起点，但最终都超越了复仇本身。《老男孩》中，吴大秀的复仇之旅实际上是一场自我认知的旅程。当真相揭开的那一刻，复仇变成了最残酷的惩罚。朴赞郁通过这些故事反复追问：复仇能带来解脱吗？还是只会让人陷入更深的痛苦？</p>
<h3>视觉语言的革命</h3>
<p>朴赞郁的电影以惊人的视觉呈现著称。《老男孩》中的横版格斗长镜头被无数影迷津津乐道，这个长达两分四十秒的镜头不仅展示了动作场面的真实感，更暗示了主角面对的重重阻碍。在《亲切的金子》中，红色从道具上升到符号层面，既是金子的标志色，也是她内心愤怒的外化。</p>
<h3>从复仇到救赎</h3>
<p>三部曲的尾声《亲切的金子》暗示了复仇之后的出路——不是在暴力中沉沦，而是在集体救赎中获得某种和解的可能。这为朴赞郁后来的作品《小姐》和《分手的决心》埋下了伏笔：从复仇到理解，从愤怒到释然，朴赞郁的电影始终在探索人性的光谱。</p>`,
    author: '李美妍',
    date: '2026-07-15',
    categorySlug: 'crime-thriller',
    relatedMovieId: 'oldboy',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20cinema%20film%20analysis%20article%20cover%2C%20Park%20Chan%20wook%20revenge%20trilogy%20theme%2C%20cinematic%20photography%20with%20red%20tones%2C%20film%20noir%20aesthetic%2C%20editorial%20design%2C%20sophisticated%20visual&width=800&height=500&seq=article-park-chan-wook&orientation=landscape',
  },
  {
    id: 'art-3',
    title: '韩国恐怖电影中的民俗密码：解构《哭声》的恐怖之源',
    slug: 'korean-horror-folklore-the-wailing',
    excerpt: '罗泓轸导演的《哭声》被誉为近年最令人不安的恐怖电影之一。本文从韩国民俗信仰角度出发，解读影片中那些令人毛骨悚然的恐怖元素背后的文化基因。',
    content: `<p>《哭声》（2016）是导演罗泓轸继《追击者》和《黄海》之后的第三部长片，也是他首次涉足超自然恐怖领域。这部156分钟的史诗级恐怖电影，将韩国民俗信仰、基督教元素和现代恐怖叙事交织在一起，创造出一个令人窒息的恐怖世界。</p>
<h3>民俗信仰的恐怖转译</h3>
<p>韩国传统萨满信仰是《哭声》的核心恐怖来源。影片中的"跳大神"仪式、符咒、稻草人诅咒等元素，都根植于韩国民间传统。罗泓轸将这些民俗元素从文化记忆转化为视觉恐怖，让韩国民众在银幕上看到了童年噩梦中的形象。</p>
<h3>外来者的隐喻</h3>
<p>影片中的日本人角色承载着复杂的历史隐喻。日本殖民时期对朝鲜半岛的影响至今仍是韩国社会的创伤记忆，《哭声》通过恐怖片的方式表达了这种集体焦虑。外来者作为灾难的源头，是韩国恐怖电影中反复出现的母题。</p>
<h3>信仰的崩塌</h3>
<p>《哭声》最令人不安的地方在于它对所有信仰体系的质疑。萨满、基督教、理性调查——没有一种方式能够完全解释或抵御影片中的邪恶。这种彻底的不可知论立场，让观众在影片结束后依然感到深深的不安。</p>`,
    author: '朴恩珠',
    date: '2026-07-10',
    categorySlug: 'horror-thriller',
    relatedMovieId: 'the-wailing',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20horror%20film%20analysis%20article%20cover%2C%20folk%20horror%20occult%20theme%2C%20dark%20ritualistic%20atmosphere%2C%20cinematic%20photography%20with%20ominous%20mood%2C%20editorial%20design%20sophisticated&width=800&height=500&seq=article-the-wailing-folklore&orientation=landscape',
  },
  {
    id: 'art-4',
    title: '《小姐》与女性凝视：朴赞郁如何颠覆男性叙事传统',
    slug: 'the-handmaiden-female-gaze',
    excerpt: '改编自英国小说《荆棘之城》，《小姐》将故事背景移至1930年代的朝鲜。朴赞郁以令人惊叹的视觉语言，完成了一次对男性凝视传统的彻底颠覆。',
    content: `<p>《小姐》（2016）改编自莎拉·沃特斯的小说《荆棘之城》，朴赞郁将维多利亚时代的英国替换为1930年代日本殖民时期的朝鲜，这一跨文化的改编不仅保留了原著的精神内核，更增添了浓郁的东亚美学韵味。</p>
<h3>三重叙事的迷宫</h3>
<p>影片采用三部分结构，每个部分从不同角色的视角重新讲述同一段故事。这种叙事策略不仅制造了惊人的反转效果，更让观众亲身体验了"被欺骗"与"发现真相"的过程。当第二部分淑熙的视角展开时，第一部分的叙事被彻底推翻——朴赞郁以此暗示所有叙事都带有偏见，真相存在于不同视角的交汇处。</p>
<h3>女性情欲的美学表达</h3>
<p>《小姐》中的情欲场景是朴赞郁导演生涯中最具争议也最具开创性的部分。他摒弃了传统电影中男性凝视下对女性身体的物化，转而以女性视角呈现情欲。镜头追随的是两位女性角色之间的情感流动，而非对身体的剥削性展示。这种处理方式在电影史上具有突破性意义。</p>
<h3>殖民语境下的权力博弈</h3>
<p>影片嵌套在殖民主义的框架之中——日本对朝鲜的殖民、男性对女性的压迫、贵族对平民的剥削，多层权力关系相互交织。淑熙和秀子最终逃出这座迷宫，不仅是对父权制的反抗，也是对被殖民身份的摆脱。</p>`,
    author: '金慧珍',
    date: '2026-07-05',
    categorySlug: 'romance-drama',
    relatedMovieId: 'the-handmaiden',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20film%20The%20Handmaiden%20analysis%20article%20cover%2C%20period%20drama%20feminine%20elegance%2C%201930s%20Korean%20aesthetic%2C%20cinematic%20photography%20with%20soft%20lighting%2C%20editorial%20design%20sophisticated&width=800&height=500&seq=article-the-handmaiden&orientation=landscape',
  },
  {
    id: 'art-5',
    title: '从《出租车司机》看韩国民主化运动电影的历史叙事',
    slug: 'taxi-driver-democratization-narrative',
    excerpt: '《出租车司机》以1980年光州事件为背景，通过一个普通司机的视角呈现了韩国民主化运动的关键时刻。本文分析历史事件如何在类型片框架中获得新的叙事力量。',
    content: `<p>2017年上映的《出租车司机》取材于真实历史事件——1980年的光州民主化运动。影片通过首尔出租车司机金万燮（宋康昊 饰）的视角，将这一重大历史事件转化为一场扣人心弦的个人冒险。</p>
<h3>小人物视角中的大历史</h3>
<p>韩国电影擅长以小人物的视角呈现宏大历史。《出租车司机》中的金万燮起初只是一个关心车费胜过民主的普通市民，但当他亲眼目睹光州街头的惨状后，他的价值观发生了根本转变。这种"普通人被历史唤醒"的叙事模式，让历史事件获得了强烈的情感共鸣。</p>
<h3>类型片的真实与虚构</h3>
<p>作为一部商业剧情片，《出租车司机》在处理历史事件时进行了必要的戏剧化改编。影片中德国记者于尔根·辛兹佩特和司机金万燮的关系被赋予了更多温情色彩，追逐场景也被强化以增强观赏性。但影片对光州事件核心真实的坚持——军队对平民的暴力镇压、市民的英勇抗争——使得这些改编获得了历史合理性。</p>
<h3>记忆的政治</h3>
<p>《出租车司机》在韩国的巨大票房成功（超过1200万人次观影）证明，韩国观众需要这样的电影来理解自己的历史。在光州事件过去近四十年后，电影成为了传递历史记忆的重要媒介。</p>`,
    author: '崔东勋',
    date: '2026-07-01',
    categorySlug: 'historical',
    relatedMovieId: 'a-taxi-driver',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20historical%20film%20A%20Taxi%20Driver%20article%20cover%2C%201980s%20Gwangju%20theme%2C%20warm%20yellow%20taxi%20visual%2C%20cinematic%20photography%20nostalgic%2C%20editorial%20design%20sophisticated&width=800&height=500&seq=article-taxi-driver&orientation=landscape',
  },
  {
    id: 'art-6',
    title: '李沧东与《燃烧》：当代韩国青年的存在困境',
    slug: 'lee-chang-dong-burning-existential-crisis',
    excerpt: '改编自村上春树的短篇小说，《燃烧》在李沧东的镜头下呈现出一种独特的当代寓言气质。影片通过三个年轻人之间的关系，探讨了阶级、欲望与存在主义的深刻命题。',
    content: `<p>李沧东导演的《燃烧》（2018）被誉为21世纪最伟大的电影之一。这部改编自村上春树短篇小说《烧仓房》的作品，在李沧东的手中呈现出远超原著的哲学深度。</p>
<h3>饥饿的隐喻</h3>
<p>影片中，海美教钟秀一个非洲部落的舞蹈——"伟大的饥饿者"之舞。这个隐喻贯穿全片：非洲人跳起舞来寻找生命的意义，正如现代人在物欲横流中追寻精神的栖居。钟秀的"小饥饿"（物质匮乏）与本的"大饥饿"（精神空虚）形成了鲜明的阶层对比，而海美则渴望从两者中都获得解放。</p>
<h3>燃烧的三种意义</h3>
<p>影片标题"燃烧"至少承载三层含义：本所说的烧毁废弃塑料棚（对社会无用者的隐喻性清除）、钟秀内心日益增长的嫉妒与愤怒之火，以及海美夕阳下脱衣起舞时的生命激情。这三重燃烧共同指向一个核心问题：在这个冷漠的世界里，什么才是真正的存在？</p>
<h3>开放性的结局</h3>
<p>《燃烧》的结局刻意保持开放——钟秀是否真的杀死了本？那些被烧毁的塑料棚真的存在吗？海美去了哪里？李沧东拒绝给出明确答案，正如生活中的许多问题永远没有标准答案。这种不确定性正是影片魅力的核心所在。</p>`,
    author: '尹瑞妍',
    date: '2026-06-25',
    categorySlug: 'crime-thriller',
    relatedMovieId: 'burning',
    coverUrl: 'https://readdy.ai/api/search-image?query=Korean%20film%20Burning%20analysis%20article%20cover%2C%20sunset%20warm%20tones%20mysterious%2C%20contemplative%20atmosphere%2C%20cinematic%20photography%20arthouse%2C%20editorial%20design%20sophisticated&width=800&height=500&seq=article-burning&orientation=landscape',
  },
];

export const testimonials = [
  {
    id: 't-1',
    name: '王晓明',
    role: '资深影评人',
    content: '韩影深解是我见过的最专业的韩国电影中文网站。每一篇影评都深入骨髓，不仅有电影本身的解析，更有对韩国社会文化的深刻洞察。强烈推荐给每一位韩国电影爱好者。',
    rating: 5,
  },
  {
    id: 't-2',
    name: '陈思雨',
    role: '电影专业研究生',
    content: '作为研究韩国电影的学生，这个网站是我的重要参考资料库。分类体系科学、文章质量上乘、观点独到深入，帮我完成了很多论文的资料收集工作。',
    rating: 5,
  },
  {
    id: 't-3',
    name: '张磊',
    role: '豆瓣资深用户',
    content: '看了十年的韩国电影，以为自己已经很懂了，直到发现了韩影深解才知道还有这么多我没注意到的细节和隐喻。这个网站真正做到了深入浅出。',
    rating: 5,
  },
  {
    id: 't-4',
    name: '林小婉',
    role: '影视从业者',
    content: '从一个从业者的角度来看，韩影深解的影评不仅专业，而且视角独特。它帮我打开了理解韩国电影的新维度，对我的创作也产生了积极影响。',
    rating: 5,
  },
];

export const faqs = [
  {
    question: '韩国电影为什么近年来在国际上如此受欢迎？',
    answer: '韩国电影的国际崛起源于多方面因素：韩国政府对文化产业的大力扶持、导演创作自由的制度保障、类型片与作者性完美结合的创作模式，以及韩国电影人对社会现实的敏锐洞察。从奉俊昊的《寄生虫》获得奥斯卡，到《鱿鱼游戏》成为全球现象级作品，韩国影视内容正以独特的叙事魅力和普世的人文关怀征服全球观众。',
  },
  {
    question: '入门韩国电影应该从哪些导演的作品开始看？',
    answer: '建议从"韩国电影四巨头"开始：奉俊昊（代表作《寄生虫》《杀人回忆》）、朴赞郁（代表作《老男孩》《小姐》）、李沧东（代表作《燃烧》《薄荷糖》）、金基德（代表作《春夏秋冬又一春》）。这四位导演风格各异，涵盖了韩国电影的主要美学方向。之后可以扩展到罗泓轸（《哭声》）、延尚昊（《釜山行》）等新一代导演。',
  },
  {
    question: '韩国犯罪悬疑电影有什么独特之处？',
    answer: '韩国犯罪悬疑电影的核心特点在于：一、对体制的深刻反思（如《杀人回忆》对警方无能的刻画）；二、复仇主题的反复出现（如《老男孩》《看见恶魔》）；三、强烈的视觉冲击力与暴力美学；四、将悬疑与社会批判深度结合。这类电影不仅仅是解谜游戏，更是对社会与人性的深度拷问。',
  },
  {
    question: '韩国电影与好莱坞电影的主要区别是什么？',
    answer: '两者最大的区别在于叙事取向和结局处理。好莱坞通常追求明确的善恶对立和圆满结局，而韩国电影更倾向于呈现道德的灰色地带和开放式的收尾。韩国电影也更愿意深入探讨社会阶级、历史创伤等严肃议题，即便在商业类型片中也保持强烈的作者意识。此外，韩国电影在暴力场面上更加直白和大胆，不回避现实的残酷性。',
  },
  {
    question: '如何理解韩国电影中反复出现的"恨"（Han）文化？',
    answer: '"恨"（Han）是韩国文化中一个独特的概念，指代一种深沉的、积压在心底的悲伤与愤怒。这种情感源于朝鲜民族在历史上经历的多次战争、殖民统治和社会动荡。在韩国电影中，"恨"以多种形式呈现——复仇的执念、对社会不公的愤怒、以及即便在最悲惨的处境中依然保持的坚韧。理解"恨"文化，是深入理解韩国电影的关键密钥。',
  },
];